<template>
    <button :type="type" :disabled="disabled" @click="$emit('click')" :primary="primary" :small="small"
            :outline="outline" v-bind:class="{'no-updates': noUpdates}">
        <slot/>
        <span class="action-message" v-if="successMessage">
            {{ successMessage }}
            <span class="successful-update successful-update--in-message"></span>
        </span>
    </button>
</template>

<script>
export default {
    name:  'CustomButton',
    props: {
        type:           {
            type:     String,
            required: false,
            default:  () => 'button',
        },
        disabled:       {
            type:     Boolean,
            required: false,
            default:  () => false,
        },
        primary:        {
            type:     Boolean,
            required: false,
            default:  () => false,
        },
        small:          {
            type:     Boolean,
            required: false,
            default:  () => false,
        },
        outline:        {
            type:     Boolean,
            required: false,
            default:  () => false,
        },
        successMessage: {
            type:     String,
            required: false,
            default:  null,
        },
        noUpdates:      {
            type:     Boolean,
            required: false,
            default:  false,
        }
    }
}
</script>
